<!-- 公共轮播图组件 -->
<template>
    <div class="hetad_banner" :style="{height:fullScreen?fullHeight:height}">
        <el-carousel :height="fullScreen?fullHeight:height" arrow="never" v-if="list.length > 0" indicator-position="none">
            <el-carousel-item v-for="(item, index) in list" :key="index">
                <div class="banner_items">
                    <el-image :src="item" :style="{height:fullScreen?fullHeight:height}" class="banner_img" fit="cover" />
                </div>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script setup>
import { reactive, defineProps, ref } from "vue";


const props = defineProps({
    list: {
        type: Array,
        default: [],
    },
    srcName: {
        type: String,
        default: 'img'
    },
    height: {
        type: String,
        default: '800px',
    },
    fullScreen: {
        type: Boolean,
        default: false
    }
})

const fullHeight = ref((window.innerHeight - 87) + 'px')




</script>

<style scoped lang='scss'>
.hetad_banner {
    width: 100%;
    min-width: 1920px !important;

    .banner_items {
        min-width: 1920px !important;

        .banner_img {
            width: 100%;
        }
    }

    &:deep(.el-carousel__button) {
        width: 24px !important;
        height: 6px !important;
        background: #d8d8d8;
        border-radius: 4px;
    }

    &:deep(.is-active .el-carousel__button) {
        width: 64px !important;
        transition: width 0.2s;
        background: #ff4817 !important;
    }
}
</style>